import axios from 'axios';
import { createPostRequest } from '../../../../helpers/request/request.js';
import { API_URLS } from '../../../../configs/constants/urls.js';
import { appendXsrfToken } from '../../../../helpers/request/utils.js';
import TokenService from '../../../../helpers/request/tokens.js';
export const loginWithApple = async (postData) => {
    try {
        if ((await TokenService.getCsrfToken()) !== true) {
            const invalidTokenError = {
                status: 401,
            };
            return invalidTokenError;
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.APPLE_LOGIN, postData, requestOptions);
        const successResponse = {
            status: response.status,
            emailUpdateRequired: response.data.emailUpdateRequired,
        };
        return successResponse;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.log('reponse error: ', error.response);
                const { correlationId, validations } = error?.response?.data ?? {};
                const failedResponse = {
                    status: error.response.status,
                    ...(correlationId && { correlationId }),
                    ...(validations && { validations }),
                };
                return failedResponse;
            }
        }
        console.log('unknown error: ', error);
        const unknownErrorResponse = {
            status: 500,
            additionalInfo: 'unknown error',
        };
        return unknownErrorResponse;
    }
};
//# sourceMappingURL=loginWithApple.js.map